import { useState, useEffect } from "react";

import { serviceCookieGet, serviceCookieSet } from "services/graphql/call";

export const useIdentityCookie = () => {
  const [cookieConsent, setCookieConsent] = useState(null);
  const [refreshCookieConsent, setRefreshCookieConsent] = useState(null);

  const handleCookieConsent = (value) => {
    serviceCookieSet("cookieConsent", value, 365);
    setRefreshCookieConsent(value);
  };

  // check for cookie consent
  useEffect(() => {
    const cookieConsentState = serviceCookieGet("cookieConsent");
    setCookieConsent(cookieConsentState);
    if (window && window.gtag) {
      if (cookieConsentState === "reject") {
        window.gtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
        });
      } else {
        window.gtag("consent", "update", {
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
          analytics_storage: "granted",
        });
      }
    }
  }, [refreshCookieConsent]);

  return [cookieConsent, handleCookieConsent];
};

// USAGE
// const [cookieConsent, handleCookieConsent] = useIdentityCookie();
